const MAX = 250;

type Props = {
    value: string;
    readOnly: boolean;
    onChange: (next: string) => void;
};

const MenteeRegistrationFreeText = ({ value, readOnly, onChange }: Props) => (
    <div className="mreg-freetext-wrap">
        <label className="mreg-field mreg-field-full" htmlFor="mreg-freetext">
            <span className="mreg-field-label mreg-field-label-upper">
                Anything specific you&apos;d like your mentor to know
            </span>
            <textarea
                id="mreg-freetext"
                className="form-control mreg-textarea"
                rows={4}
                value={value}
                maxLength={MAX}
                disabled={readOnly}
                readOnly={readOnly}
                onChange={(e) => onChange(e.target.value.slice(0, MAX))}
                placeholder="e.g. I'm targeting IB roles at Tier-1 banks post-MBA. Would love guidance on CFA vs CPA…"
            />
        </label>
        <p className="mreg-hint mreg-counter">
            {value.length} / {MAX}
        </p>
    </div>
);

export default MenteeRegistrationFreeText;
